import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  loginUser,
  getUserProfileByToken,
  fetchAllUsers,
} from '../../api/userApi'

export const userLoginThunk = createAsyncThunk(
  'user/login',
  async (credentials: { email: string; password: string }, thunkAPI) => {
    try {
      const response = await loginUser(credentials)
      console.log(response)
      if (response.success) {
        console.log(response)
        return response.data
      } else {
        return thunkAPI.rejectWithValue(response.message)
      }
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.message)
    }
  }
)

export const fetchUserProfileByToken = createAsyncThunk(
  'user/fetchUserProfileByToken',
  async (token: string, thunkAPI) => {
    try {
      const response = await getUserProfileByToken(token)
      if (response.success) {
        return response.data
      } else {
        return thunkAPI.rejectWithValue(response.message)
      }
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.message)
    }
  }
)

// Create a thunk for fetching all users
export const fetchAllUsersThunk = createAsyncThunk(
  'user/fetchAllUsers',
  async (_, thunkAPI) => {
    try {
      const response = await fetchAllUsers()
      if (response.success) {
        return response.users // Assuming the response data contains an array of users
      } else {
        return thunkAPI.rejectWithValue(response.message)
      }
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.message)
    }
  }
)
